// Renders breadcrumb bar given array of link properties

import { useState, useCallback } from 'react'
import {
  Input,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Row,
  Col
} from 'reactstrap'
import Router from 'next/router'
import Link from 'next/link'
import { SEARCH_TYPES } from '~/lib/constants/search'
import PropTypes from 'prop-types'

function SearchBar ({ search, searchType }) {
  const [searchState, setSearch] = useState(search || '')
  const handleSetSearch = useCallback(event => setSearch(event.target.value), [])

  // Search changed
  const handleSearch = useCallback(() => {
    const searchStateTrimmed = searchState.trim()

    if (searchStateTrimmed.length > 0) {
      const query = { q: searchStateTrimmed }
      if (searchType && searchType.length > 0) {
        query.searchType = searchType
      }

      Router.push({ pathname: '/search', query }, { pathname: '/search', query })
        .then(() => window.scrollTo(0, 0))
    }
  }, [searchType, searchState])

  // Enter pressed
  function handleKeyPress (event) {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  return (
    <Col xs='12' md='3' className='mb-3'>
      <InputGroup>
        <InputGroupAddon addonType='prepend'>
          <InputGroupText className='bg-white'>
            <i className='fa fa-search fa-lg' />
          </InputGroupText>
        </InputGroupAddon>
        <Input
          className='border-left-0'
          value={searchState}
          placeholder={`Search ${SEARCH_TYPES[searchType] || ''}`}
          maxLength='50'
          onChange={handleSetSearch}
          onKeyPress={handleKeyPress}
        />
      </InputGroup>
    </Col>
  )
}

SearchBar.propTypes = {
  search: PropTypes.string,
  searchType: PropTypes.string
}

function BreadcrumbBar ({ breadcrumbs, searchType, search, alwaysShow }) {
  return (
    <Row className={`breadcrumb-bar row-border-bottom mb-4 ${alwaysShow ? '' : 'd-none d-md-flex'}`}>
      <Col xs='9' className='breadcrumb-path pt-2 pb-3 d-none d-md-block'>
        {breadcrumbs.map(({ name, href, as }, index) => (
          <span key={index}>
            {index !== 0 && <span className='pl-1 pr-1'>/</span>}
            <Link href={href} as={as}><a>{name}</a></Link>
          </span>
        ))}
      </Col>
      {searchType !== undefined && <SearchBar key={search} search={search} searchType={searchType} />}
    </Row>
  )
}

BreadcrumbBar.propTypes = {
  breadcrumbs: PropTypes.array.isRequired,
  searchType: PropTypes.string,
  search: PropTypes.string,
  alwaysShow: PropTypes.bool
}

export default BreadcrumbBar
